
import React, { useState, useEffect } from "react";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import BusinessPage from "./components/BusinessPage";
import ContactPage from "./components/ContactPage";
import TendersPage from "./components/TendersPage"; 
import SuppliersPage from "./components/SuppliersPage";

const App = () => {
  const [currentPage, setCurrentPage] = useState("home");

  // Render the current page
  const renderCurrentPage = () => {
    switch (currentPage) {
      case "home":
        return <HomePage setCurrentPage={setCurrentPage} />;
      case "about":
        return <AboutPage setCurrentPage={setCurrentPage} />;
      case "business":
        return <BusinessPage setCurrentPage={setCurrentPage} />;
      case "tenders":
       return <TendersPage setCurrentPage={setCurrentPage} />;
      case "suppliers":
        return  <SuppliersPage setCurrentPage={setCurrentPage}/>;
      case "contact":
        return <ContactPage setCurrentPage={setCurrentPage} />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} />;
    }
  };

  return renderCurrentPage();
};

export default App;